export const SET_SEO_DATA = 'lv3/SET_SEO_DATA';
export const SET_SEO_FILTERS = 'lv3/SET_SEO_FILTERS';
export const CRUISE_SEO_DATA = 'lv3/CRUISE_SEO_DATA';
